import React, { FC } from 'react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { Field, Icon, Toggle, Tooltip } from '@kontentino/ui';
import { Attachments } from 'types/Attachments';
type Props = {
  value: Pick<Attachments, 'shareToFeed'>;
  onChange: (
    fn: (attachments: Attachments) => Pick<Attachments, 'shareToFeed'>,
  ) => void;
};

const PostComposerContentInstagramShareToFeed: FC<Props> = ({
  value,
  onChange,
}) => {
  return (
    <Field.Group>
      <Field.Label required>
        Share to feed
        <Tooltip
          content={
            'If checked, indicates the reel should appear in both the Feed and Reels tabs.'
          }
        >
          <Icon
            icon={faCircleInfo}
            size="sm"
            className="tw-ml-1 tw-text-grayscale-100"
          />
        </Tooltip>
        <Toggle
          checked={value.shareToFeed || false}
          onChange={() =>
            onChange((prev) => ({ shareToFeed: !prev.shareToFeed }))
          }
          className="tw-ml-auto"
        />
      </Field.Label>
    </Field.Group>
  );
};

export default PostComposerContentInstagramShareToFeed;
